module.exports = __webpack_public_path__ + "img/cert-back.b8bce38a.png";